import React, { useState } from 'react'
import * as pageUtils from './__index.utils'
import { DOCUMENT_ENVOYE_FORM } from './__index.utils'
import { docIcon, excelIcon, imgIcon, pdfIcon, wordIcon } from '@images/icons'
import { RepereIntegrationRepository } from '@services/repositories'

type propsType = {
	requeteGUID: string
	documentsEnvoyes: DOCUMENT_ENVOYE_FORM[]
}

const DocumentsEnvoyesSection: React.FC<propsType> = ({
	requeteGUID,
	documentsEnvoyes
}) => {
	const groupByCatDoc = (
		docs: DOCUMENT_ENVOYE_FORM[]
	): Record<string, DOCUMENT_ENVOYE_FORM[]> => {
		return docs.reduce((acc, doc) => {
			;(acc[doc.CAT_DOC] = acc[doc.CAT_DOC] || []).push(doc)
			return acc
		}, {} as Record<string, DOCUMENT_ENVOYE_FORM[]>)
	}

	const displayAttachements = () => {
		let attachments: any = []
		Object.entries(
			groupByCatDoc(documentsEnvoyes.length > 0 ? documentsEnvoyes : [])
		).forEach(([key, value]: [string, DOCUMENT_ENVOYE_FORM[]]) => {
			attachments.push(
				<div key={`${key}`} style={{ marginBottom: '15px', fontSize: '15px' }}>
					<p style={{ margin: '0 0 5px 0' }}>
						<b>{key}</b>
					</p>

					{getAttachements(value)}
				</div>
			)
		})

		return attachments
	}

	// Mapping mimeType / extensions vers icônes
	const iconByMimeType = (mimeType: string, fileName: string) => {
		if (mimeType.includes('pdf')) return pdfIcon
		if (
			mimeType.includes('word') ||
			fileName.toLowerCase().endsWith('.doc') ||
			fileName.toLowerCase().endsWith('.docx')
		)
			return wordIcon
		if (
			mimeType.includes('excel') ||
			fileName.toLowerCase().endsWith('.xls') ||
			fileName.toLowerCase().endsWith('.xlsx')
		)
			return excelIcon

		if (
			mimeType.startsWith('image/') ||
			fileName.toLowerCase().endsWith('.jpg') ||
			fileName.toLowerCase().endsWith('.jpeg') ||
			fileName.toLowerCase().endsWith('.png')
		)
			return imgIcon
		return docIcon
	}

	function removeTimestampFromFilename(filename: string): string {
		// Remplace _[suite de chiffres] juste avant l'extension par rien
		return filename.replace(/_\d+(?=\.[^.]+$)/, '')
	}

	const RepereRepository = new RepereIntegrationRepository()

	const [downloadingIndex, setDownloadingIndex] = useState<string>('')

	const onClickDownload = async (item: DOCUMENT_ENVOYE_FORM) => {
		try {
			setDownloadingIndex(item.PREF_ID)
			const fileUrl = await RepereRepository.getInitialDocument({
				referenceId: item.PREF_ID,
				filename: item.FICHE_NOM,
				returnAsUrl: true,
				requeteGUID: requeteGUID
			})

			const response = await fetch(fileUrl)
			const blob = await response.blob()
			const url = window.URL.createObjectURL(blob)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', removeTimestampFromFilename(item.FICHE_NOM))
			document.body.appendChild(link)
			link.click()
			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			console.error('Erreur lors du téléchargement :', error)
		} finally {
			setDownloadingIndex('')
		}
	}

	const getAttachements = (files: DOCUMENT_ENVOYE_FORM[]) => {
		return files.map((item: DOCUMENT_ENVOYE_FORM, key) => (
			<div key={key} className={pageUtils.classes.attachmentItem}>
				<div className={pageUtils.classes.attachmentItemInfo}>
					<div className="flexCenter">
						<img
							src={iconByMimeType(item.MIME_TYPE, item.FICHE_NOM)}
							alt="pdf"
							style={{ width: 26 }}
						/>
					</div>
					<div className={pageUtils.classes.attachmentItemName}>
						<span>{removeTimestampFromFilename(item.FICHE_NOM)}</span>
						<br />
						<span style={{ fontSize: '14px', color: '#666' }}>
							{item.DATE_MAJ} ({item.TAILLE})
						</span>
					</div>
				</div>

				<div
					className={pageUtils.classes.attachmentItemDownload}
					onClick={() =>
						downloadingIndex !== '' ? undefined : onClickDownload(item)
					}
					style={{
						cursor: downloadingIndex == item.PREF_ID ? 'wait' : 'pointer'
					}}
				>
					{downloadingIndex == item.PREF_ID ? (
						<span className="loader" />
					) : (
						'Télécharger'
					)}
				</div>
			</div>
		))
	}

	return (
		<div>
			{documentsEnvoyes.length > 0 ? (
				displayAttachements()
			) : (
				<p
					className={pageUtils.classes.paragraph}
					style={{ marginBottom: '15px' }}
				>
					Aucun document envoyé
				</p>
			)}
		</div>
	)
}

export default DocumentsEnvoyesSection
